import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const ToolsRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--tools']}>
    <Route index element={<Index />} />
  </SubRouter>
))
